import React from 'react';

const Features = () => {
    return (
        <div className='mt-5 text-center'>
            <h1 style={{ color: 'goldenrod' }}>Testimonials</h1>
            <div className='m-5 mt-0 w-50 mx-auto'>
                <p>“What a phenomenal experience! We contacted and hired normal package. She nailed it. The pictures turned out amazing. Too good actually... the hardest part was narrowing our photographs down for our wedding book!”</p>
                <h6 className='text-end'>    — — DORA + MARKO OF PHILADELPHIA, PA</h6>
                <p className='mt-5'>“She is extraordinary in kindness, response time, creativity, professionalism, and value. The quality of her photography and cinematography are amazing! We absolutely love our premium Italian wedding photo book.”</p>
                <h6 className='text-end'>— — MANDY + EDDIE OF SCRANTON, PA</h6>
            </div>
        </div>
    );
};

export default Features;